<template>
  <div>
    <div class="contact-table" v-if="totalNum>0">
      <div class="title">共 <span>{{totalNum}}</span> 条数据</div>
      <div v-for="(item,index) in list" :key="index" style="margin-bottom:10px">
        <div class="list" >
        <div class="itemDiv">
          <div class="itemconter">
          <div class="itemLabel">邮件主题:</div>
          <template>
            <div class="table-item-specialFocus">
              <el-tooltip
                effect="light"
                :content="item.title"
                placement="bottom"
                popper-class="customer-management-potential-companyName-tooltip"
              >
                <p class="table-item-specialFocus-name" >
                  <span
                    :ref="'specialFocusStrTootip' + index"
                    style="color: #066eb7; cursor: pointer; width: 80%"
                  >
                    <div class="itemVal itemValTitle"  @click="jumpDetail(item)">{{ item.title | noText}}</div>
                  </span>
                </p>
              </el-tooltip>
            </div>
          </template>
          
          </div>
          <!-- <div class=""> -->
          <el-tag :type="item.isRead?'':'info'"   size="mini" class="tagType">{{item.isRead?'已查看':'未查看'}}</el-tag>
          <!-- </div> -->
          <!-- 邮件时间 -->
          <div class="sendTime">{{item.createTime | format('YYYY-MM-DD HH:mm:ss')}}</div>
        </div>
        <div class="itemDiv">
          <div class="itemconter">
            <div class="itemLabel">收件人:</div>
            <div class="itemVal">{{item.userName}} &lt;{{ item.tosEmail  }}&gt;</div>
          </div>
        </div>
        <div class="itemDiv">
          <div class="itemconter">
          <div class="itemLabel">发件人:</div>
          <div class="itemVal">{{item.sendEmail | noText}}</div>
          </div>
        </div>
        <!-- <div class="explicate editMailBody" v-html="item.content"></div> -->
        </div>
      </div>

      <div style="text-align: center; margin-top: 26px; margin-bottom: 31px">
        <!-- :current-page="currentPage4" -->
        <el-pagination
          background
          layout="prev, pager, next"
          :total="totalNum"
          :page-size="5"
          :currentPage.sync="currentPage"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <div v-else>
      <div
        class="noData"
        style="text-align: center; margin-top: 120px"
      >
        <img
          src="../../../src/assets/image/common/noData.png"
          alt=""
          style="322px;height:99px;"
        />
        <span>暂无数据···</span>
      </div>
    </div>
  </div>

</template>
  
  <script>
import moment from "moment";
import { presentUrl } from '@/utils/config.js'
export default {
  props: {
    list: {
      default: () => [],
      type: Array,
    },
    isLoading: {
      type: Boolean,
    },
    totalNum: {
      type: Number,
    },
  },
  data() {
    return {
      currentPage: 1,
    };
  },
  methods: {
    // 切换页数
    handleCurrentChange(val) {
      this.currentPage = val;
      this.$emit("getEmailList", this.currentPage);
      const ele = document.querySelector(".custom-concat-list");
      ele.scrollTop = 0;
    },
    // 跳转
    jumpDetail(item){
      let routeUrl =presentUrl +this.$router.resolve({
        name: 'mail-detail',
        query: { id:item.edmId}
      }).href;
      window.open(routeUrl, '_blank');
    },
  },
};
</script>
  
<style  lang="scss" scoped>
.title {
  color: #16181aff;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  margin-bottom: 10px;
  span {
    color: #066eb7ff;
    font-weight: 500;
  }
}
.list {
  // width: 572px;
  // height: 165px;
  background: #f5f7fa;
  border-radius: 4px;
  padding: 14px 20px;
  .itemDiv {
    display: flex;
    margin-bottom: 6px;
    .itemconter {
      display: flex;
      .itemLabel {
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #4f5d78;
      }
      .itemVal {
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #16181a;
        margin-left: 8px;
      }
      .itemValTitle{
        cursor: pointer;
        color: #066EB7;
        word-wrap: break-word;
        max-width: 236px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .tagType {
      margin-left: 12px;
    }
    .sendTime {
      position: absolute;
      right: 16px;
      font-family: ArialMT;
      font-size: 14px;
      color: #4f5d78;
    }
  }
  .explicate {
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #16181a;
    text-align: justify;
    line-height: 20px;
    border-top: 1px solid #cfd5df;
    margin-top: 10px;
    padding-top: 8px;
  }
  ::v-deep .editMailBody{
    div,
    span,
    object,
    li,
    ul,
    img iframe,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    pre,
    a,
    em,
    img,
    strong,
    sub,
    sup,
    b,
    i,
    dl,
    dt,
    dd,
    ol,
    ul,
    li,
    fieldset,
    form,
    label,
    legend,
    table,
    tbody,
    tfoot,
    thead,
    tr,
    th,
    td,
    article,
    aside,
    canvas,
    details,
    embed,
    figure,
    figcaption,
    footer,
    header,
    menu,
    nav,
    output,
    ruby,
    section,
    abstractDesc,
    time,
    mark,
    audio,
    video,
    input,
    textarea,
    select,
    button,
    meter,
    progress {
      margin: revert;
    }
    a {
      color: rgb(0, 0, 238) !important;
    }
    img {
      width: 100% ;
    }
    table{
      width: 526px !important;
    }
  }
}
.noData {
    span {
      display: block;
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #98a3b7;
      margin-top: 16px;
    }
  }
</style>
  <style lang="scss">
</style>